import { render, staticRenderFns } from "./BarnSilos.vue?vue&type=template&id=17565b82&scoped=true&"
import script from "./BarnSilos.vue?vue&type=script&lang=js&"
export * from "./BarnSilos.vue?vue&type=script&lang=js&"
import style0 from "./BarnSilos.vue?vue&type=style&index=0&id=17565b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17565b82",
  null
  
)

export default component.exports